import {injectable} from 'inversify';
import {CustomPlacePanel} from "@/scenes.ui/custom-place-panel";
import {Answer, AwardType, Replica} from "@/store/meet/types";
import {OverchargePanel} from "@/scenes.ui/overcharge-panel";
import {CustomPlaceContainer} from "@/scenes.ui/custom-place-container";
import {CustomPlace, PlaceDisplayType, SkillType} from "@/store/place/types";
import {CustomPlaceDialog} from "@/scenes.ui/custom-place-dialog";
import MeetStore from "@/store/meet";
import PlayerStore from "@/store/player";
import SoundUtils from "@/utils/sound-utils";
import {AvatarShopPanel} from "@/scenes.ui/avatar-shop-panel";
import ShopStore from "@/store/shop";
import {AvatarDto, HeroShopType} from "@/store/shop/types";
import CU from "@/utils/c-u";
import {MenuService} from "@/services/menu-service";
import Scene = Phaser.Scene;
import PlaceStore from "@/store/place";
import {PartIntroPanel} from "@/scenes.ui/part-intro-panel";
import BlackoutText from "@/scenes.ui/blackout-text";
import {Tr} from "@/i18n/i18n";
import Blackout from "@/scenes.ui/blackout";
import EducationPanel from "@/scenes.ui/education-panel";
import {Creature} from "@/store/level/types";
import {CreatureSelectPanel} from "@/scenes.ui/creatures-grid-select-panel";
import CreatureStore from "@/store/creature";

@injectable()
export class CustomPlaceService {

    private menuService!: MenuService;

    public initDialog(scene: Scene, canvas: HTMLCanvasElement, place: CustomPlace,
                      awardSound: Phaser.Sound.BaseSound | undefined, clickSound: Phaser.Sound.BaseSound | undefined,
                      completedCallback: (removePlace: boolean, setCompleted: boolean) => unknown, battleCallback: (placeId: number) => unknown,
                      shopCallback: () => unknown, reloadSceneCallback: () => unknown,
                      openCastleShopCallback: (heroShopType: HeroShopType) => unknown, unlockRoadCallback: () => unknown,
                      removeDialogIconCallback: ()=>void, createDialogIconCallback: ()=> void,
                      menuService: MenuService, runSpecialCommand: (id: string) => unknown, makeCustomPlaceCallback: (p:CustomPlace) => unknown): CustomPlaceContainer {

        this.menuService = menuService;
        let self = this;
        let handler = () => {
            let replica: Replica = MeetStore.getReplica()!;

            dialogPanel.init(replica, (answer: Answer) => {
                if (answer.specialCommand) {
                    SoundUtils.play(clickSound);

                    if (answer.specialCommand.startsWith("spawnPlace")){
                        let placeToSpawn = answer.specialCommand.split("|")[1];
                        let drawPlace = () => {
                            PlaceStore.fetchPlaces(PlayerStore.getCoordinate(), PlayerStore.getCoordinate() - 1000, PlayerStore.getCoordinate() + 1000).then(() => {
                                PlaceStore.getPlacesAll().forEach(p => {
                                    if (p instanceof CustomPlace) {
                                        if (p.placeId == placeToSpawn) {
                                            makeCustomPlaceCallback(p);
                                        }
                                    }
                                });
                            });
                        }
                        this.doAnswer(place.id, awardSound, clickSound, completedCallback, battleCallback, reloadSceneCallback, dialogPanel, answer, drawPlace);
                    } else {
                        switch (answer.specialCommand) {
                            case 'showP7intro':
                                this.doAnswer(place.id, awardSound, clickSound, completedCallback, battleCallback, reloadSceneCallback, dialogPanel, answer);
                                let ip: PartIntroPanel = new PartIntroPanel(scene, canvas, PlayerStore.getPlayer().lang, 7, () => {
                                    SoundUtils.play(awardSound);
                                    ip.close();
                                });
                                SoundUtils.play(clickSound);
                                ip.openAnimated();
                                break;
                            case 'absX':
                                runSpecialCommand(answer.specialCommand);
                                this.doAnswer(place.id, awardSound, clickSound, completedCallback, battleCallback, reloadSceneCallback, dialogPanel, answer);
                                runSpecialCommand('absXAfter');
                                break;
                            case 'absX2':
                            case 'absX3':
                            case 'absXU':
                                runSpecialCommand(answer.specialCommand);
                                this.doAnswer(place.id, awardSound, clickSound, completedCallback, battleCallback, reloadSceneCallback, dialogPanel, answer);
                                break;
                            case 'openHeroTownShop':
                                openCastleShopCallback(HeroShopType.HERO_TOWN);
                                break;
                            case 'openArtifactTownShop':
                                openCastleShopCallback(HeroShopType.ARTIFACT_TOWN);
                                break;
                            case 'openMonasteryShop':
                                openCastleShopCallback(HeroShopType.MONASTERY_SHOP);
                                break;
                            case 'openOblivionShop':
                                openCastleShopCallback(HeroShopType.OBLIVION_SHOP);
                                break;
                            case 'openTitanTownShop':
                                openCastleShopCallback(HeroShopType.TITAN_TOWN);
                                break;
                            case 'openSurTownShop':
                                openCastleShopCallback(HeroShopType.SUR_TOWN);
                                break;
                            case 'openYotunTownShop':
                                openCastleShopCallback(HeroShopType.YOTUN_TOWN);
                                break;
                            case 'openAngelTownShop':
                                openCastleShopCallback(HeroShopType.ANGEL_TOWN);
                                break;
                            case 'openAmetistShop':
                                openCastleShopCallback(HeroShopType.AMETIST_SHOP);
                                break;
                            case 'openCaviarRankShop':
                                openCastleShopCallback(HeroShopType.RANK_SHOP);
                                break;
                            case 'openCaviarElephShop':
                                openCastleShopCallback(HeroShopType.ELEPH_SHOP);
                                break;
                            case 'openWaterShop':
                                openCastleShopCallback(HeroShopType.WATER_SHOP);
                                break;
                            case 'openPortalShop':
                                openCastleShopCallback(HeroShopType.PORTAL_SHOP);
                                break;
                            case 'openShadowShop':
                                openCastleShopCallback(HeroShopType.SHADOW_SHOP);
                                break;
                            case 'openAvatarShop':
                                ShopStore.fetchAvatars().then((avs: AvatarDto[]) => {
                                    self.openAvatarShop(scene, canvas, avs, dialogPanel, clickSound, shopCallback, unlockRoadCallback);
                                });
                                break;
                            case 'openAvatarShopAtlantis':
                                ShopStore.fetchAtlantisAvatars().then((avs: AvatarDto[]) => {
                                    self.openAvatarShop(scene, canvas, avs, dialogPanel, clickSound, shopCallback, unlockRoadCallback);
                                });
                                break;
                            case 'openAvatarShopShip':
                                ShopStore.fetchShipAvatars().then((avs: AvatarDto[]) => {
                                    self.openAvatarShop(scene, canvas, avs, dialogPanel, clickSound, shopCallback, unlockRoadCallback);
                                });
                                break;
                            case 'p1_completed':
                                let bt = new BlackoutText(scene, canvas);
                                bt.show([Tr('p1.1'), Tr('p1.2'), Tr('p1.3'), Tr('p1.4'), Tr('p1.5'),
                                    Tr('p1.6'), Tr('p1.7'), Tr('p1.8'), Tr('p1.9'), Tr('p1.10')], () => {
                                    this.doAnswer(place.id, awardSound, clickSound, completedCallback, battleCallback, reloadSceneCallback, dialogPanel, answer);
                                });
                                break;
                            case 'p2_completed':
                                let bt2 = new BlackoutText(scene, canvas);
                                bt2.show([Tr('p2.1'), Tr('p2.2'), Tr('p2.3'), Tr('p2.4'), Tr('p2.5'),
                                    Tr('p2.6'), Tr('p2.7'), Tr('p2.8'), Tr('p2.9')], () => {
                                    this.doAnswer(place.id, awardSound, clickSound, completedCallback, battleCallback, reloadSceneCallback, dialogPanel, answer);
                                });
                                break;
                            case 'p3_completed':
                                let bt3 = new BlackoutText(scene, canvas);
                                bt3.show([Tr('p3.1'), Tr('p3.2'), Tr('p3.3'), Tr('p3.4'), Tr('p3.5'),
                                    Tr('p3.6'), Tr('p3.7')], () => {
                                    this.doAnswer(place.id, awardSound, clickSound, completedCallback, battleCallback, reloadSceneCallback, dialogPanel, answer);
                                });
                                break;
                            case 'p4_completed':
                                let bt4 = new BlackoutText(scene, canvas);
                                bt4.show([Tr('p4.1'), Tr('p4.2'), Tr('p4.3'), Tr('p4.4'), Tr('p4.5'),
                                    Tr('p4.6'), Tr('p4.7')], () => {
                                    this.doAnswer(place.id, awardSound, clickSound, completedCallback, battleCallback, reloadSceneCallback, dialogPanel, answer);
                                });
                                break;
                            case 'p8_to_mirograd':
                                let bt8 = new BlackoutText(scene, canvas);
                                bt8.show([Tr('p8.1'), Tr('p8.2'), Tr('p8.3'), Tr('p8.4'), Tr('p8.5'), Tr('p8.6')], () => {
                                    this.doAnswer(place.id, awardSound, clickSound, completedCallback, battleCallback, reloadSceneCallback, dialogPanel, answer);
                                });
                                break;
                            case 'p8_to_abyss':
                                let bt9 = new BlackoutText(scene, canvas);
                                bt9.show([Tr('p8.7'), Tr('p8.8'), Tr('p8.9'), Tr('p8.10'), Tr('p8.11'), Tr('p8.12')], () => {
                                    this.doAnswer(place.id, awardSound, clickSound, completedCallback, battleCallback, reloadSceneCallback, dialogPanel, answer);
                                });
                                break;
                            case 'p8_from_abyss':
                                let bt10 = new BlackoutText(scene, canvas);
                                bt10.show([Tr('p8.13'), Tr('p8.14'), Tr('p8.15'), Tr('p8.16'), Tr('p8.17'), Tr('p8.18'), Tr('p8.19')], () => {
                                    this.doAnswer(place.id, awardSound, clickSound, completedCallback, battleCallback, reloadSceneCallback, dialogPanel, answer);
                                });
                                break;
                            case 'lighten':
                                let cpd2: CustomPlaceDialog = dialogPanel as CustomPlaceDialog;
                                cpd2.depth = CustomPlaceDialog.DEPTH;
                                EducationPanel.TEXT_DELAY = 100;
                                Blackout.hide();
                                this.doAnswer(place.id, awardSound, clickSound, completedCallback, battleCallback, reloadSceneCallback, dialogPanel, answer);
                                break;
                            case 'p9_text':
                                (BlackoutText as any).isCentered = true;
                                let btP9Part1 = new BlackoutText(scene, canvas);
                                btP9Part1.show([Tr('p9.1'), Tr('p9.2'), Tr('p9.3')], () => {
                                    this.doAnswer(place.id, awardSound, clickSound, completedCallback, battleCallback, reloadSceneCallback, dialogPanel, answer);
                                });
                                break;
                            case 'p9_text2':
                                (BlackoutText as any).isCentered = true;
                                let btP9Part2 = new BlackoutText(scene, canvas);
                                btP9Part2.show([Tr('p9.4'), Tr('p9.5'), Tr('p9.6'), Tr('p9.7')], () => {
                                    this.doAnswer(place.id, awardSound, clickSound, completedCallback, battleCallback, reloadSceneCallback, dialogPanel, answer);
                                });
                                break;
                            case 'transferStatsPanel':
                                this.showStrangeMagPanel(scene, canvas);
                                menuService.onChange();
                                this.doAnswer(place.id, awardSound, clickSound, completedCallback, battleCallback, reloadSceneCallback, dialogPanel, answer);
                                break;
                            default:
                                runSpecialCommand(answer.specialCommand);
                                this.doAnswer(place.id, awardSound, clickSound, completedCallback, battleCallback, reloadSceneCallback, dialogPanel, answer);
                                break;
                        }
                    }


                } else if (answer.optionalPay && answer.optionalPay.overcharge > 0) {
                    SoundUtils.play(clickSound);
                    let aop: OverchargePanel = new OverchargePanel(scene!, canvas!,
                        300 * CU.S, canvas.height / 2 - 50, answer.optionalPay.amount, answer.optionalPay.overcharge, () => {
                            if (answer.optionalPay!.overcharge <= PlayerStore.getPlayer()!.mithril) {
                                SoundUtils.play(awardSound);
                                aop.close();
                                this.doAnswer(place.id, awardSound, clickSound, completedCallback, battleCallback, reloadSceneCallback, dialogPanel, answer);
                            } else {
                                SoundUtils.play(clickSound);
                                shopCallback!();
                            }
                        });
                    aop.openAnimated();
                } else if (answer.optionalPay && answer.optionalPay.amount.mithril > PlayerStore.getPlayer()!.mithril) {
                    SoundUtils.play(clickSound);
                    shopCallback!();
                } else {
                    this.doAnswer(place.id, awardSound, clickSound, completedCallback, battleCallback, reloadSceneCallback, dialogPanel, answer);
                }

                if(answer.specialCommand && answer.specialCommand.includes("removePlaceImage")){
                    completedCallback(true, false);
                }

                if(answer.specialCommand && answer.specialCommand.includes("updateBuffs")){
                    menuService.onChange();
                }
            });
        };

        let dialogPanel: CustomPlaceContainer = CustomPlaceService.createContainer(scene, canvas, place.placeDisplayType, completedCallback, removeDialogIconCallback, createDialogIconCallback);
        if (place.firstReplica) {
            MeetStore.SET_REPLICA(place.firstReplica);
            place.firstReplica = undefined;
            handler();
        } else {
            MeetStore.fetchReplica(place.id).then(() => {
                handler();
            });
        }
        return dialogPanel;
    }

    private openAvatarShop(scene: Scene, canvas: HTMLCanvasElement, avs: AvatarDto[], dialogPanel: CustomPlaceContainer,
                           clickSound: Phaser.Sound.BaseSound | undefined, shopCallback: () => unknown, unlockRoadCallback: () => unknown) {
        let avatarPanel = new AvatarShopPanel(scene, canvas, avs, (index: number) => {
            let a = avs[index];
            if (a.price <= PlayerStore.getPlayer().mithril) {
                ShopStore.buyAvatar(a.id);
            } else {
                SoundUtils.play(clickSound);
                shopCallback!();
            }
        });
        avatarPanel.setCloseListener(() => {
            dialogPanel.close();
            unlockRoadCallback();
        });
        avatarPanel.openAnimated();
    }

    private doAnswer(placeId: number,
                     awardSound: Phaser.Sound.BaseSound | undefined, clickSound: Phaser.Sound.BaseSound | undefined,
                     completedCallback: (removePlace: boolean, setCompleted: boolean) => unknown, battleCallback: (placeId: number) => unknown,
                     reloadSceneCallback: () => unknown,
                     dialogPanel: CustomPlaceContainer, answer: Answer, onAnswer?:() => unknown) {
        SoundUtils.play(clickSound);
        let self = this;

        let handler = (replica: Replica) => {
            if (replica.toBattle) {
                battleCallback(placeId);
            } else if (replica.replicaId) {
                if (replica.award) {
                    SoundUtils.play(awardSound);
                }
                dialogPanel.setup(replica);
            } else {
                dialogPanel.close();
                completedCallback(replica.removePlace!, replica.setDone!);

                if (replica.player && replica.player.requestSpecialPlaces) {
                    PlayerStore.getPlayer().coordinate = replica.player.coordinate;
                    reloadSceneCallback();
                }
            }

            if (!replica.player && answer.awardDelta && answer.awardDelta !== 0 && answer.awardType) {
                switch (answer.awardType) {
                    case AwardType.GOLD:
                        PlayerStore.INC_GOLD(answer.awardDelta);
                        break;
                    case AwardType.CRYSTAL:
                        PlayerStore.INC_CRYSTAL(answer.awardDelta);
                        break;
                    case AwardType.ELIXIR:
                        PlayerStore.INC_ELIXIR(answer.awardDelta);
                        break;
                    case AwardType.MITHRIL:
                        PlayerStore.INC_GEMS(answer.awardDelta);
                        break;
                    case AwardType.ATTACK_FOR_ALL:
                        self.menuService.showCreatureSkillEffect(SkillType.ATTACK, answer.awardDelta);
                        break;
                    case AwardType.DEFENCE_FOR_ALL:
                        self.menuService.showCreatureSkillEffect(SkillType.DEFENCE, answer.awardDelta);
                        break;
                    case AwardType.HEALTH_FOR_ALL:
                        self.menuService.showCreatureSkillEffect(SkillType.HEALTH, answer.awardDelta);
                        break;
                    case AwardType.ATTACK_FOR_ONE:
                        self.menuService.showCreatureSkillEffect(SkillType.ATTACK, answer.awardDelta, answer.crId);
                        break;
                    case AwardType.DEFENCE_FOR_ONE:
                        self.menuService.showCreatureSkillEffect(SkillType.DEFENCE, answer.awardDelta, answer.crId);
                        break;
                    case AwardType.HEALTH_FOR_ONE:
                        self.menuService.showCreatureSkillEffect(SkillType.HEALTH, answer.awardDelta, answer.crId);
                        break;
                    case AwardType.EXPERIENCE:
                        PlayerStore.INC_EXP(answer.awardDelta);
                        break;
                    case AwardType.GOOD_POINTS:
                        PlayerStore.INC_GOOD_POINTS(answer.awardDelta);
                        break;
                    case AwardType.EVIL_POINTS:
                        PlayerStore.INC_EVIL_POINTS(answer.awardDelta);
                        break;
                    case AwardType.GOOD_AND_EVIL_POINTS:
                        PlayerStore.INC_GOOD_POINTS(answer.awardDelta);
                        PlayerStore.INC_EVIL_POINTS(answer.awardDelta);
                        break;
                    case AwardType.TICKETS:
                        PlayerStore.INC_TICKETS(answer.awardDelta);
                        break;
                }
            }
        }


        let r: Replica = MeetStore.getReplica()!;
        if (answer.nextReplica) {
            MeetStore.answer(r.placeId!, r.replicaId!, answer.id!, false).then(() => {
                if (onAnswer) onAnswer();
            });
            MeetStore.SET_REPLICA(answer.nextReplica);
            handler(answer.nextReplica);
        } else {
            MeetStore.answer(r.placeId!, r.replicaId!, answer.id!, true).then(() => {
                r = MeetStore.getReplica()!;
                handler(r);
                if (onAnswer) onAnswer();
            });
        }
    }

    private static createContainer(scene: Scene, canvas: HTMLCanvasElement, placeDisplayType: PlaceDisplayType,
                                   exitCallback: (removePlace: boolean, setCompleted: boolean) => unknown,
                                   removeDialogIconCallback: ()=>void, createDialogIconCallback: ()=> void): CustomPlaceContainer {
        switch (placeDisplayType) {
            case PlaceDisplayType.PANEL:
                return new CustomPlacePanel(scene, canvas, exitCallback);
            case PlaceDisplayType.DIALOG:
                return new CustomPlaceDialog(scene, canvas, removeDialogIconCallback, createDialogIconCallback);
        }
        throw new Error("Unknown place display type");
    }

    public showStrangeMagPanel(scene: Scene, canvas: HTMLCanvasElement): void {
        const player = PlayerStore.getPlayer();
        const validCreatures = player.creatures.filter(c => c && !c.temporal);

        const sourceCandidates: Creature[] = [];
        for (const c of validCreatures) {
            const atk = c.skills.find(s => s.skillType === SkillType.ATTACK);
            const def = c.skills.find(s => s.skillType === SkillType.DEFENCE);
            const hp = c.skills.find(s => s.skillType === SkillType.HEALTH);

            const hasStats =
                (atk && atk.valueTotal > 1 && atk.valueCurrent > 1) ||
                (def && def.valueTotal > 1 && def.valueCurrent > 1) ||
                (hp && hp.valueTotal > 1 && hp.valueCurrent > 1);

            if (hasStats) {
                sourceCandidates.push(c);
            }
        }

        if (sourceCandidates.length === 0) {
            return;
        }
        let selectedSource: Creature | null = null;

        const grid1 = new CreatureSelectPanel(scene, canvas, (sourceIndex) => {
            selectedSource = sourceCandidates[sourceIndex];
            if (!selectedSource) return;
            grid1.destroy();

            const targetCandidates = validCreatures.filter(c => c.id !== selectedSource!.id);
            const grid2 = new CreatureSelectPanel(scene, canvas, (targetIndex) => {
                const selectedTarget = targetCandidates[targetIndex];
                if (!selectedTarget) return;
                grid2.destroy();
                scene.time.delayedCall(50, () => {
                    CreatureStore.transferStats(selectedSource!.id, selectedTarget.id);
                });
            }, targetCandidates, Tr('select.target'));

            grid2.open();
            scene.add.existing(grid2);
        }, sourceCandidates, Tr('select.source'));

        grid1.open();
        scene.add.existing(grid1);
    }
}
